import { render, staticRenderFns } from "./CustomerHistory.vue?vue&type=template&id=34e52e14&scoped=true&"
import script from "./CustomerHistory.vue?vue&type=script&lang=js&"
export * from "./CustomerHistory.vue?vue&type=script&lang=js&"
import style0 from "./CustomerHistory.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomerHistory.vue?vue&type=style&index=1&id=34e52e14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e52e14",
  null
  
)

export default component.exports